<template>
  <Component :is="tag" class="v-defer">
    <slot v-if="visible" />
  </Component>
</template>

<script setup lang="ts">
import { nextTick, ref } from 'vue'

import { delay as delayFn, nextFrame } from '../utils/helpers.ts'

interface Props {
  delay?: number
  frames?: number
  tag?: string
  ticks?: number
}

const { ticks = 0, frames = 1, delay = -1 } = defineProps<Props>()

defineSlots<{
  default?(): any
}>()

async function defer(ticks: number, frames: number) {
  if (delay > -1) {
    await delayFn(delay)
  }

  for (let i = 0; i < ticks; i++) {
    await nextTick()
  }

  for (let i = 0; i < frames; i++) {
    await nextFrame()
  }
}

const visible = ref(false)
defer(ticks, frames).then(() => (visible.value = true))
</script>
